import { Edit, Delete } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { GridRowParams, GridActionsCellItem } from '@mui/x-data-grid';
import { Booking, BookingState } from '@thro-types/leihbar';

import { t } from 'i18next';
import { useCallback } from 'react';

import { useSelfEntitlementGroupsQuery } from 'api/hooks/users';
import { translations } from 'locales/i18n';

import { isLenderOfProduct } from '../helper';

interface Props {
  handleEdit: (booking: Booking) => void;
  handleStorno: (booking: Booking) => void;
}

export const BookingGridRowActions = ({ handleEdit, handleStorno }: Props) => {
  const { data: myEntitlementGroups } = useSelfEntitlementGroupsQuery();
  return useCallback(
    (params: GridRowParams<Booking>) => {
      if (!params.row.article?.product) {
        return [];
      }
      const isEditDisabled =
        params.row.state === BookingState.RETURNED ||
        params.row.deletedAt !== null ||
        !isLenderOfProduct(params.row.article.product, myEntitlementGroups);
      const isCancelDisabled =
        params.row.state === BookingState.COLLECTED ||
        params.row.state === BookingState.RETURNED ||
        params.row.deletedAt !== null ||
        !isLenderOfProduct(params.row.article.product, myEntitlementGroups);
      return [
        <Tooltip
          title={
            params.row.state === BookingState.RETURNED
              ? t(translations.pages.leihbar.daily.tooltips.disabledEdit.returned())
              : !isLenderOfProduct(params.row.article.product, myEntitlementGroups)
              ? t(translations.pages.leihbar.daily.tooltips.disabledEdit.notLender())
              : ''
          }
          //@ts-ignore This is required because otherwise the item is not being rendered in the menu: https://github.com/mui/mui-x/issues/14045
          showInMenu
        >
          <span>
            <GridActionsCellItem
              icon={
                <Edit
                  style={{
                    color: 'lightblue'
                  }}
                />
              }
              label={t(translations.common.edit())}
              onClick={() => {
                handleEdit(params.row);
              }}
              showInMenu
              disabled={isEditDisabled}
            />
          </span>
        </Tooltip>,
        <Tooltip
          title={
            params.row.state === BookingState.COLLECTED ||
            params.row.state === BookingState.RETURNED
              ? t(translations.pages.leihbar.daily.tooltips.disabledCancel.collected())
              : !isLenderOfProduct(params.row.article.product, myEntitlementGroups)
              ? t(translations.pages.leihbar.daily.tooltips.disabledCancel.notLender())
              : ''
          }
          //@ts-ignore This is required because otherwise the item is not being rendered in the menu: https://github.com/mui/mui-x/issues/14045
          showInMenu
        >
          <span>
            <GridActionsCellItem
              icon={
                <Delete
                  style={{
                    color: 'red'
                  }}
                />
              }
              label={t(translations.common.storno())}
              onClick={() => {
                handleStorno(params.row);
              }}
              showInMenu
              disabled={isCancelDisabled}
            />
          </span>
        </Tooltip>
      ];
    },
    [myEntitlementGroups, handleEdit, handleStorno]
  );
};
